import { render, staticRenderFns } from "./ctrlgeo.vue?vue&type=template&id=5147b657"
import script from "./ctrlgeo.vue?vue&type=script&lang=js"
export * from "./ctrlgeo.vue?vue&type=script&lang=js"
import style0 from "./ctrlgeo.vue?vue&type=style&index=0&id=5147b657&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports